import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import {
  HaynesProElectronicLocationGroupModel,
  HaynesProElectronicLocationSystemModel
} from '../typings/haynes-pro.diagnostic-tool.electronic-location-details';

import { HaynesProService }  from '../haynes-pro.service';
import { MessagesService }   from '../../messages/messages.service';
import { VehicleModel }      from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-electronic-locations',
  styles: [ require('./haynes-pro.diagnostic-tool.electronic-locations.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.electronic-locations.component.html')
})
export class HaynesProDiagnosticToolElectronicLocationsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProLocationsBlock') block : NgBlockUI;
  @Input() isActive : boolean;
  @Input() vehicle  : VehicleModel;

  location : HaynesProElectronicLocationSystemModel = null;
  groups   : Array<HaynesProElectronicLocationGroupModel>;
  group    : HaynesProElectronicLocationGroupModel;
  subGroups: Array<HaynesProElectronicLocationSystemModel>;

  isAnimating  = false;
  showDetails  = false;

  constructor (
    private cdr              : ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    private messagesService  : MessagesService,
    private zone             : NgZone
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.group
        ? this.group
        : this.groups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    this.block.start();

    this.haynesProService.getLocationsBySubject(this.vehicle)
    .then(( groups : Array<HaynesProElectronicLocationGroupModel> ) => {
      this.groups = groups;

      if ( !this.isActive ){
        this.haynesProService.updateSubscriptionStatus(true);
      }
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
      if (this.isActive) {
        this.groups[0].selected = true;
        this.group = this.groups[0];
      }
    });
  }

  backToLists () : void {
    this.isAnimating = true;
    this.showDetails = false;

    this.cdr.markForCheck();

    setTimeout(() => this.isAnimating = false, 450);
  }

  handleGroupSelection ( group : HaynesProElectronicLocationGroupModel ) : void {
    if (this.subGroups) {
      this.subGroups.forEach(( subGroup : any ) => subGroup.selected = false);
    }

    this.location    = null;
    this.showDetails = false;
    this.isAnimating = false;
    this.subGroups   = group?.location_systems;
  }

  handleSubgroupSelection ( subGroup : HaynesProElectronicLocationSystemModel ) : void {
    this.isAnimating = false;
    this.location    = null;
    this.showDetails = false;
    this.location    = subGroup;

    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.zone.run(() => {
            this.isAnimating = true;
            this.showDetails = true;

            this.cdr.markForCheck();

            setTimeout(() => this.isAnimating = false, 450);
          });
        });
      });
    });
  }

  onCssTransitionEnd ( evt: TransitionEvent ) : void {
    const target = (evt.target as HTMLElement);

    if (!target.classList.contains('shell-details')) {
      return;
    }

    if (evt.propertyName !== 'transform' && evt.propertyName !== 'opacity') {
      return;
    }

    this.isAnimating = false;
  }

}